<script setup lang="ts">
import type { Article } from "~/types/article"

withDefaults(
  defineProps<{
    title?: string
    data: Article
  }>(),
  {
    title: "Laster...",
  },
)

const productContent = useProductContentStore()

const loginPageUrl = useLoginPageUrl()
</script>

<template>
  <div
    class="relative flex size-full overflow-clip rounded-xl bg-platform-paper font-national2condensed text-black"
    :class="{
      'flex-row-reverse': data.template === 'UTextWithImageArticle',
    }"
  >
    <img
      v-if="data.img && data.img.src"
      class="h-full w-1/2 object-cover"
      :class="{ 'brightness-50': data.restricted }"
      :src="data.img?.src"
      :alt="data.img?.alt"
    />

    <div
      class="relative flex size-full flex-col items-start bg-platform-paper p-3 pt-4 lg:p-10 lg:pt-14"
      :class="{
        'max-w-2/4': data.img && data.img.src,
        'px-5 lg:px-32': !data?.img?.src,
      }"
    >
      <div>
        <h4
          class="text-md hidden pb-3.5 font-national2 font-extrabold uppercase text-darker lg:block lg:text-lg"
        >
          {{ productContent.activeSubject?.title }}
        </h4>
        <h3
          class="mb-2 line-clamp-3 max-w-96 overflow-clip whitespace-pre-line text-2xl font-medium lg:mb-6 lg:mt-0 lg:text-4xl xl:text-5xl"
          :class="{
            'mt-6': data.restricted,
          }"
          v-html="data.titleHtml ? data.titleHtml : title"
        />
      </div>
      <URichText
        v-if="!data.restricted"
        inert
        :html="data.body?.html.trim()"
        class="w-full text-xs lg:text-lg [&_.text-link]:no-underline"
      />
      <p
        v-else
        class="my-auto font-national2 text-xs font-bold text-dark lg:text-lg"
      >
        Kjøp tilgang for å se innholdet i dette kapittelet
        <span class="whitespace-nowrap font-normal">Allerede tilgang?
          <UButton
            v-if="loginPageUrl"
            :to="loginPageUrl"
            variant="quite"
            size="xs"
            theme="medium"
            class="inline underline"
          >
            Logg inn
          </UButton>
          <template v-else>Logg inn</template>
        </span>
      </p>
    </div>
    <UIcon
      v-if="data.restricted"
      name="lock-filled"
      class="absolute left-4 top-4 text-white"
      :class="{
        '!text-darker':
          !data.img?.src || data.template === 'UTextWithImageArticle',
      }"
      size="lg"
    />
  </div>
</template>
